import React from 'react';
import diagram from '../../../assets/image-empty1.PNG';
const ProcedurePrev = ({ formData }) => {
  return (
    <>
      <div className="procedure-prev-heading  w-[83vw] h-[80vh] overflow-auto ">
        <p className="text-base font-medium">Procedure Preview</p>

        <div
          className="procedure-prev h-auto w-[90vw] rounded-xl p-4"
          style={{ backgroundColor: ' #eceff4' }}
        >
          <div className="heading">
            <p className="text-xs font-medium ">Table of content</p>
          </div>
          {formData.map((field, index) => (
            <>
              <div className="step-prev">
                <div className="heading font-semibold">
                  <p
                    className=" text-medium font-semibold"
                    style={{ color: '#fe104d', textTransform: 'capitalize' }}
                  >
                    {field.id}
                  </p>
                </div>
                <div className="step-detail bg-white rounded-md w-[80vw] ">
                  <div className="step-text p-2 w-[90vw]">
                    <p className="text-sm font-base">
                      {field.tableOfContent !== '' ? (
                        field.tableOfContent
                      ) : (
                        <>
                          tuscon cooking is caractirized by heaving simple food,
                          not covered in heavy sauces cooking is done with olive
                          oil(not butter) as is user
                        </>
                      )}
                    </p>
                    {/* image1 */}
                    <div className="image-main flex flex-wrap">
                      {field.images.length > 0 ? (
                        field.images.map((_img, _index) => (
                          <>
                            <div className="image  flex my-2 mx-4">
                              <img
                                className="h-8 w-8 rounded-lg"
                                src={_img.src}
                                alt=""
                              />
                            </div>
                          </>
                        ))
                      ) : (
                        <>
                          <div className="image  flex my-2 mx-4">
                            <img
                              className="h-8 w-8 rounded-lg"
                              src={diagram}
                              alt=""
                            />
                          </div>
                          {/* image2*/}
                          <div className="image  flex my-2 mx-4">
                            <img
                              className="h-8 w-8 rounded-lg"
                              src={diagram}
                              alt=""
                            />
                          </div>
                          {/* image3 */}
                          <div className="image  flex my-2 mx-4">
                            <img
                              className="h-8 w-8 rounded-lg"
                              src={diagram}
                              alt=""
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="info-h">
                      <p
                        className=" text-medium font-semibold"
                        style={{ color: '#fe104d' }}
                      >
                        Information notes
                      </p>
                      <p className="text-sm font-base w-[90vw] px-4">
                        {field.information !== '' ? (
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: field.information,
                              }}
                            ></div>
                          </>
                        ) : (
                          <>
                            tuscun cooking is charactirized by having simple
                            food not covered
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="decision-prev">
                <div className="dec-prev">
                  <p
                    className=" text-medium font-semibold"
                    style={{ color: '#fe104d' }}
                  >
                    Decision:
                  </p>
                </div>
                {field.decisions.map((_dec, _index) => (
                  <div className="dec-detail bg-white rounded-md  w-[80vw]">
                    <p className="text-sm font-base p-3">
                      {_dec.textContent}
                      {/* tuscun cooking is charactirized by having simple food not
                      covered */}
                    </p>

                    <a
                      href={_dec.link}
                      target="_blank"
                      className="text-blue-600 underline text-sm font-base p-3"
                    >
                      {_dec.link}
                    </a>
                  </div>
                ))}
              </div>

              <div className="diagram-prev">
                <div className="dec-prev">
                  <p
                    className=" text-medium font-semibold"
                    style={{ color: '#fe104d' }}
                  >
                    Diagrams:
                  </p>
                  <div className="diagram-prev-detail bg-white rounded-md w-[80vw]">
                    <div className="image-main flex  flex-wrap">
                      {field.diagrams.map((_dia, _index) => (
                        <div className="image  flex my-2 mx-8">
                          <img
                            className="h-20 w-20 rounded-lg"
                            src={_dia.src}
                            alt=""
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProcedurePrev;
